<!-- <app-modal-header title="Create Warehouse Sensor" (closeModal)="closeDialog()"></app-modal-header> -->
<div class="form-holder">
  <!-- <main-dynamic-form
            class="py-5"
            [fields]="sensorAlertConfigFields"
            [loading]="loading"
            [showRequiredTitle]="false"
            loadingMessage="Saving your data, please wait..."
            [confirmFirst]="true"
            confirmMessage="You are about to save your data. Do you want to continue?"
            [form]="supportForm"
            (submit)="submitForm($event)">
    </main-dynamic-form> -->
    <form [formGroup]="alertConfigForm" (ngSubmit)="submitForm()">
        <div class="grid grid-cols-12 gap-2">
          <mat-form-field class="col-span-3" appearance="outline">
            <mat-label>Max Temperature</mat-label>
            <input matInput formControlName="maxTemperature" placeholder="Max Temperature" type="number" />
          </mat-form-field>
      
          <mat-form-field class="col-span-3" appearance="outline">
            <mat-label>Min Temperature</mat-label>
            <input matInput formControlName="minTemperature" placeholder="Min Temperature" type="number" />
          </mat-form-field>
      
          <mat-form-field class="col-span-3" appearance="outline">
            <mat-label>Max Humidity</mat-label>
            <input matInput formControlName="maxHumidity" placeholder="Max Humidity" type="number" />
          </mat-form-field>
      
          <mat-form-field class="col-span-3" appearance="outline">
            <mat-label>Min Humidity</mat-label>
            <input matInput formControlName="minHumidity" placeholder="Min Humidity" type="number" />
          </mat-form-field>
      
          <mat-form-field class="col-span-3" appearance="outline">
            <mat-label>Occurrence Circles</mat-label>
            <input matInput formControlName="occurenceCircles" placeholder="Occurrence Circles" type="number" />
          </mat-form-field>
          <mat-form-field class="col-span-3" appearance="outline">
            <mat-label>Number of Responders</mat-label>
            <mat-select formControlName="circlesToEscalation">
              <mat-option *ngFor="let esc of [1,2,3,4,5]" [value]="esc">
                {{ esc }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          
        <mat-form-field class="col-span-3" appearance="outline">
          <mat-label>Escalation Period (mins)</mat-label>
          <input matInput formControlName="escalationPeriod" placeholder="Escalation Period(mins)" type="number" />
        </mat-form-field>
        @if(validationError){
        <p class="col-span-3 text-red-600 text-sm">Escalation Period cannot be less than 10 mins</p>
        }
        </div>
        <div formArrayName="alertReceivers" *ngFor="let receiver of alertConfigForm.get('alertReceivers')['controls']; let i = index">
            <div [formGroupName]="i" class="grid grid-cols-12 gap-2">
              <mat-form-field class="col-span-6" appearance="outline">
                <mat-label>{{ escalationLeveles[i]?.name }}</mat-label>
                <input matInput formControlName="level" placeholder="Escalation Level" />
              </mat-form-field>
        
              <mat-form-field class="col-span-6" appearance="outline">
                <mat-label>Receiver</mat-label>
                <mat-select formControlName="receiver">
                  <mat-option *ngFor="let asignee of asignees$ | async" [value]="asignee?.userList[0]?.uniqueId">
                    {{ asignee?.userList[0]?.firstName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        
          <button type="submit" class="p-2 bg-primary text-white rounded-md float-end">Save</button>
        </form>
      
</div>
